<template>
  <div class="share-top-container u-center">
    <!-- paylaş ikonu -->
    <OButton class="u-center text-sm font-medium text-primary-300" pure @click.stop="handleClick">
      <OIcon icon="article/share"></OIcon>
    </OButton>
    <!-- desktop tasarım -->
    <div v-if="!isMobile" ref="shareContainer" class="relative">
      <div
        class="flex justify-center absolute top-3 -left-3 flex-row z-3 bg-white items-center p-2 gap-1 rounded-lg shadow-md"
        :class="isClick ? 'showicons' : 'hidden'"
      >
        <SocialButton v-for="item in stickyButtons" :key="item" :article="article" :button-type="item" is-kesfet />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, inject, ref, onMounted } from '@nuxtjs/composition-api';
import { throttle } from 'lodash';
import SocialButton from '~/modules/article/components/sticky/SocialButton.vue';
import { eventBus } from '~/modules/common/utils/eventBus';
import { useOutsideClick } from '~/composables/useOutsideClick';
import { useDevice } from '~/composables/useDevice';
import OButton from '~/modules/common/components/ui/OButton/OButton.vue';
import OIcon from '~/modules/common/components/ui/OIcon/OIcon.vue';

export default defineComponent({
  components: { SocialButton, OButton, OIcon },
  setup() {
    const article = inject('article');
    const stickyButtons = ['facebook', 'twitter', 'whatsapp', 'telegram', 'google', 'copy'];
    const shareContainer = ref();
    const isClick = ref(false);
    const { isMobile } = useDevice();

    const handleClick = () => {
      if (isMobile.value) {
        eventBus.emit('isArticleShareModalOpen', article);
      }
      isClick.value = !isClick.value;
    };

    useOutsideClick(shareContainer, () => {
      if (isClick.value) isClick.value = false;
    });
    const getScrollGap = () => {
      const h = document.documentElement;
      const currentScrollTop = h.scrollTop;
      if (currentScrollTop - 10 < h.scrollTop && !isClick.value) {
        return false;
      }
    };
    const toggleVisibility = throttle(() => {
      isClick.value = getScrollGap();
    }, 100);

    onMounted(() => {
      window.addEventListener('scroll', toggleVisibility);
    });

    return {
      article,
      handleClick,
      stickyButtons,
      isClick,
      isMobile,
      shareContainer,
    };
  },
});
</script>
